import { FormValueScope, formField } from '@epages/react-components'
import Immutable from 'immutable'

import { RichTextField as RichTextFieldRaw } from '../formComponents/RichTextField'
import { useTranslate } from '../../utils/translate'
import FormGroup from '../formComponents/FormGroup'
import FormValue from '../formComponents/FormValue'
import InputField from '../formComponents/InputField'
import RadioButtonField from '../formComponents/RadioButtonField'
import useHelpCenterLink from '../../utils/hooks/useHelpCenterLink'

const RichTextField = formField()(RichTextFieldRaw)

export default function CookieSettings() {
  const cookieNoticeNs = 'components.bottomBar.storefrontSettings.cookieNotice'
  const helpCenterLink = useHelpCenterLink('COOKIES')

  const t = useTranslate('interface')

  return (
    <FormValueScope name="cookieNotice">
      <>
        <div className="dali-settingslayer-element">{t(`${cookieNoticeNs}.description`)}</div>
        <FormValue name="active">
          {(active: boolean) =>
            active ? null : <p className="ep-notification-warning">{t(`${cookieNoticeNs}.warningMessage`)}</p>
          }
        </FormValue>
        <FormGroup label={t(`${cookieNoticeNs}.visibilitySection.title`)} name="active">
          <RadioButtonField
            buttons={[
              {
                label: t(`${cookieNoticeNs}.visibilitySection.yesRadioButtonLabel`),
                value: true,
              },
              {
                label: t(`${cookieNoticeNs}.visibilitySection.noRadioButtonLabel`),
                value: false,
              },
            ]}
          />
        </FormGroup>
        <FormGroup label={t(`${cookieNoticeNs}.headlineInputField.label`)} name="title">
          <InputField />
        </FormGroup>
        <FormGroup label={t(`${cookieNoticeNs}.messageLabel`)} name="gdprMessageHtml">
          <RichTextField toolbarButtons={['bold', 'link|unlink']} />
        </FormGroup>
        <a href={helpCenterLink} target="_blank" className="ep-form-row-text-external-link" rel="noreferrer noopener">
          {t(`${cookieNoticeNs}.helpCenterLink`)}
        </a>
      </>
    </FormValueScope>
  )
}

CookieSettings.displayName = 'CookieSettings'
CookieSettings.defaultValue = Immutable.fromJS({
  active: false,
  title: '',
  gdprMessageHtml: '<span></span>',
})
